import { render, staticRenderFns } from "./LandingAllNewOnboarding.vue?vue&type=template&id=0348cb29&scoped=true"
import script from "./LandingAllNewOnboarding.vue?vue&type=script&lang=js"
export * from "./LandingAllNewOnboarding.vue?vue&type=script&lang=js"
import style0 from "./LandingAllNewOnboarding.vue?vue&type=style&index=0&id=0348cb29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348cb29",
  null
  
)

export default component.exports